import { CompassRoleTranslator } from 'src/translators/CompassRoleTranslator'
import { useGetCompassRolesQuery } from 'src/types/generated'

export const useGetCompassRoles = () => {
  const { loading, data, error } = useGetCompassRolesQuery()

  return {
    loading,
    compassRoles: data ? CompassRoleTranslator.toEntities(data.compassRoles) : [],
    error,
  }
}
